import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "checkmark", "specSection", "specTitle", "noSelection"]

  connect() {
    this.selectedTruck = "long-range"
    this.updateSelection()
  }

  selectTruck(event) {
    const clickedOption = event.currentTarget
    const truckType = clickedOption.dataset.truckType

    // Toggle selection if clicking the same truck
    if (this.selectedTruck === truckType) {
      this.selectedTruck = null
    } else {
      this.selectedTruck = truckType
    }

    this.updateSelection()
  }

  updateSelection() {
    // Update option cards
    this.optionTargets.forEach((option) => {
      const truckType = option.dataset.truckType
      const checkmark = option.querySelector('[data-truck-selector-target="checkmark"]')

      if (truckType === this.selectedTruck) {
        option.classList.add("border-blue-600")
        option.classList.remove("border-transparent")
        checkmark.classList.remove("opacity-0")
      } else {
        option.classList.remove("border-blue-600")
        option.classList.add("border-transparent")
        checkmark.classList.add("opacity-0")
      }
    })

    // Update spec sections
    this.specSectionTargets.forEach((section) => {
      const sectionType = section.dataset.truckType

      if (sectionType === this.selectedTruck) {
        section.classList.remove("hidden")
      } else {
        section.classList.add("hidden")
      }
    })

    // Update title and no selection message
    if (this.selectedTruck) {
      this.specTitleTarget.textContent =
        this.selectedTruck === "long-range" ? "Long Range Specifications" : "Standard Range Specifications"
      this.noSelectionTarget.classList.add("hidden")
    } else {
      this.specTitleTarget.textContent = "Select a truck configuration"
      this.noSelectionTarget.classList.remove("hidden")
    }
  }
}
